import { Component, OnInit } from '@angular/core';
import { HttpClientModule } from '@angular/common/http'; 
import { Http, Response } from '@angular/http';
import { GetFilteredDataService } from './filter/get-filtered-data.service'; 
import { ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import { StoreService } from './../store.service';


import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';

@Component({
  selector: 'app-display-profiles',
  templateUrl: './display-profiles.component.html',
  styleUrls: ['./display-profiles.component.css']
})
export class DisplayProfilesComponent implements OnInit {

  BASE_URL = 'http://localhost:4201/api'; 
  constructor( public afAuth: AngularFireAuth,
              private http : Http, 
              private get_filtered_data : GetFilteredDataService, 
              private $store : StoreService, 
              private route : ActivatedRoute
               ) { }


  loading: boolean
  var1 = 'no_displaying' ; 

  ngOnInit() {

    this.loading = true

    this.$store.allUsers ? 
      this.loading = false : 
          this.$store.fetchAllData().then(() => {
            this.loading = false
        })

        $(window).scroll(function() {
          if ($(document).scrollTop() > 50) {
            $('.main_container').css('padding-top', '85px'); 
          } else {
            $('.main_container').css('padding-top', '95px'); 
          }
        });


  }

  getToProfile(email) {
    this.$store.router = {
      profile: true, 
      params: email
    }
  }
  
  getFilteredUsers() {
      if (!this.$store.allUsers) return [] 
      if (this.$store.searchedSkills_array[0] === 'else') {
        var filteredUsers = this.$store.allUsers.filter(user =>
          this.$store.searchedSkills_array.find(
            skill => 
            user.skills.find(
              userSkill => 
                 skill[0] === userSkill.skillId 
                && 
                  skill[1].find ( s => {if (s) { return s.level === userSkill.level}} )
                && 
                  (skill[1][0].certified ? userSkill.certified === 1 : 1 === 1) )
        ))
        var $export = []

        filteredUsers.forEach(
          fu =>  {
            var fuSkill = fu.skills
            fuSkill = fu.skills.filter(
              us => this.$store.searchedSkills_array.find(
                s => us.skillId === s[0] && s[1].find(
                    l => 
                    us.level === l.level)
                    )
                )
            fu.filteredSkills = fuSkill
          }
        ) 
        this.$store.filteredUsers = filteredUsers
        return this.$store.filteredUsers

      }
      else {
      var filteredUsers = this.$store.allUsers.filter(user =>
        this.$store.searchedSkills_array.every(
          skill => 
          user.skills.find(
            userSkill => skill[0] === userSkill.skillId 
              && skill[1].find ( s => {if (s) { return s.level === userSkill.level }})
              && (skill[1][0].certified ? userSkill.certified === 1 : 1 === 1))
      ))
      var $export = []

      filteredUsers.forEach(
        fu =>  {
          var fuSkill = fu.skills
          fuSkill = fu.skills.filter(
            us => this.$store.searchedSkills_array.find(
               s => us.skillId === s[0] && s[1].find(
                  l => 
                  us.level === l.level)
                  )
              )
          fu.filteredSkills = fuSkill
        }
      ) 
      filteredUsers.sort((a, b) => a.familyName.localeCompare(b.familyName))
      this.$store.filteredUsers = filteredUsers
      return this.$store.filteredUsers
      
    }

  }

  // getFilteredUsers() {
  //   if (!this.$store.allUsers) return [] 
  //   this.$store.filteredUsers = this.$store.allUsers
  // }

}



// WEBPACK FOOTER //
// C:/Users/Elise/essaiGit3/Converteo-Referentiel-RH/public/src/app/display-profiles/display-profiles.component.ts